
export const enumKeys = <O extends object, K extends keyof O = string & keyof O> (obj: O) =>  {
    return Object.keys(obj).filter(k => Number.isNaN(+k)) as K[];
}
export const enumValues = <O extends object, K extends O[keyof O] = O[keyof O]> (obj: O) =>  {
    return Object.values(obj).filter(k => !Number.isNaN(+k)) as K[];
}